
type Range = [number, number];


type TypingOptions = {
  autoStart?: boolean;
  delayRange?: Range;
  lengthRange?: Range;
  content?: string;
  onTyped?: (typed: string, completed: boolean) => void;
};

// const DEFAULT_DELAY_RANGE: Range = [50, 200];
// const DEFAULT_LENGTH_RANGE: Range = [1, 4];
const DEFAULT_DELAY_RANGE: Range = [50, 100];
const DEFAULT_LENGTH_RANGE: Range = [4, 10];

export class SimulateTyping {
  private typing: boolean = false;
  private acceptable: boolean = false;
  private completed: boolean = false;
  private options: Required<TypingOptions>;
  public untyped: string = '';
  public typed: string = '';

  constructor(options?: TypingOptions) {
    this.options = {
      delayRange: DEFAULT_DELAY_RANGE,
      lengthRange: DEFAULT_LENGTH_RANGE,
      content: '',
      onTyped: () => { },
      autoStart: true,
      ...options,
    };
    this.untyped = this.options.content || '';
    this.options.autoStart && this.start();
  }

  start() {
    this.acceptable = true;
    // 继续启动
    this.accept('');
  }

  accept(content: string) {
    // 如果未关闭，才能接续接受内容
    if (this.acceptable) {
      this.untyped += content;
      this.processTypingStream();
    }
  }

  pause() {
    // 不再接受内容添加，对应服务端输出结束，但是会继续输出完成未输出的内容。
    this.acceptable = false;
  }

  close() {
    // 不再接受内容添加，对应服务端输出结束，但是会继续输出完成未输出的内容。
    this.acceptable = false;
    this.completed = true;
    this.processTypingStream();
  }

  private async processTypingStream() {
    // 如果已经暂停，则重新启动，已经 typing 中，则忽略
    if (this.typing) {
      return;
    }
    const {
      delayRange,
      lengthRange,
      onTyped,
    } = this.options;
    const [minDelay, maxDelay] = delayRange;
    const [minLength, maxLength] = lengthRange;
    this.typing = true;

    while (this.untyped.length) {
      const delay = Math.floor(Math.random() * (maxDelay - minDelay + 1)) + minDelay;
      await new Promise(resolve => setTimeout(resolve, delay));

      const chunkLength = Math.floor(Math.random() * (maxLength - minLength + 1)) + minLength;
      const [typed, untyped] = splitStr(this.untyped, chunkLength);
      this.untyped = untyped;
      this.typed += typed; // 已输出
      // 完成的条件是：不再接收新消息，且内容已全部输出完成
      this.completed = !this.acceptable && untyped.length === 0;
      if (!this.completed) {
        // 输出中，调用回调
        onTyped(this.typed, false);
      }
    }
    if (this.completed) {
      // 已完成，调用回调
      onTyped(this.typed, true);
    }
    this.typing = false;
  }
}

function splitStr(str: string, pos: number) {
  return pos > str.length ? [str, ''] : [str.slice(0, pos), str.slice(pos)];
}

// 模拟打字
export function simulateTyping(options?: TypingOptions): SimulateTyping {
  return new SimulateTyping(options);
};